import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { errorPageStyles } from "./error-page.css";
import "../error-tile";

@customElement("wow-error-page")
export class WowErrorPage extends LitElement {
  static override styles = [errorPageStyles];

  @property({ type: String })
  errorCode = "404";

  @property({ type: String })
  override title = "Page Not Found";

  @property({ type: String })
  message = "The page you're looking for doesn't exist.";

  @property({ type: String })
  buttonText = "Go Home";

  @property({ type: String })
  buttonHref = "/";

  private creators: { handle: string; image: string }[] = [
    {
      handle: "giel",
      image:
        "https://worldofwow.com/assets/profile_pictures/ff26d71a-35b4-4511-bbaa-77d822366927/b615a172-65f3-40b2-ac73-06a91cc62cf1.jpg",
    },
    {
      handle: "nienkeplas",
      image:
        "https://worldofwow.com/assets/profile_pictures/35faa870-59f2-413d-bf62-d3cdc88d07d2/2f1db09b-9bb5-462d-a62d-2ba037e87874.jpg",
    },
    {
      handle: "ricoverhoeven",
      image:
        "https://worldofwow.com/assets/profile_pictures/6a40703f-13a3-4110-aae3-fc9fb209a272/64df9b27-200a-4c69-bfe3-e07a1f8f1a6c.jpg",
    },
    {
      handle: "saraverwoerd",
      image:
        "https://worldofwow.com/assets/profile_pictures/8f1aa8c0-0a00-41a8-9692-0adfbbe467c2/fd8cdc57-3373-45f0-bfa7-6ba7139b3577.jpeg",
    },
    {
      handle: "kalvijn",
      image:
        "https://worldofwow.com/assets/profile_pictures/138e96d1-8345-4b0d-bdf9-6ce7e159f50a/e13ceb6a-a965-45ab-bb9a-27b5c85a607b.jpg",
    },
    {
      handle: "lisamichels",
      image:
        "https://worldofwow.com/assets/profile_pictures/1a3c83ca-0a1c-42e6-981e-b3db6dd6035b/75ed8d2d-9943-4cc8-b894-5a2eaffa4f50.jpg",
    },
  ];

  protected override render() {
    return html`
      <div class="error-page">
        <!-- Main Content -->
        <div class="content">
          <div class="error-content">
            <svg width="127" height="48" viewBox="0 0 127 48" fill="currentColor">
              <path
                fill="inherit"
                d="M 34.3,48 H 31.5 V 35.5 H 0 L 24,0 h 10.3 v 29.4 h 7.2 v 6.1497 L 34.3,35.5 Z M 17,29.4 H 31.5 V 7 Z"
              />
              <path
                fill="inherit"
                d="M 119.8,48 H 117 V 35.5 H 85.5 L 109.5,0 h 10.3 v 29.4 h 7.2 v 6.1497 L 119.8,35.5 Z M 102.5,29.4 H 117 V 7 Z"
              />
              <path
                fill="inherit"
                d="M 76.4795,48 H 58.5566 L 49,0.001953 h 8.3398 V 0 H 76.4795 Z M 66.5,43.3 h 8 V 7 H 60 Z"
              />
            </svg>

            <h1 class="error-title">${this.title}</h1>
            <p class="error-message">${this.message}</p>
          </div>
        </div>

        <div class="devider">
          <span>OR</span>
        </div>
        <div class="content">Check out some of our top creators.</div>

        <!-- Decorative Background Cards -->
        <div class="background-cards">
          <div class="card-group card-group-1">
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
          </div>
          <div class="card-group card-group-2">
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
            ${this.creators.map(
              ({ handle, image }) => html` <wow-error-tile handle=${handle} image=${image}></wow-error-tile> `,
            )}
          </div>
        </div>
      </div>
    `;
  }
}
